"use strict";

exports.__esModule = true;
exports.BM_EXPERIMENTS = void 0;
const BM_EXPERIMENTS = {
  MOTO: 'specs.membership.EnableMoto',
  DEALER_BANNERS: 'specs.membership.DealerBanners',
  CUSTOM_FORMS_SHOW_NEW_BADGE: 'specs.membership.CustomFormsShowNewBadge',
  BLOCKS_WIDGET: 'specs.membership.UseBlocksSinglePlanWidget',
  ONBOARDING_CHECKLIST: 'specs.membership.OnboardingChecklist',
  GALLERY: 'specs.membership.GalleryBM',
  EDIT_BENEFITS: 'specs.membership.ArchivedPlanEditBenefits',
  SETTINGS_IMPROVEMENTS: 'specs.membership.SettingsImprovements',
  INCREASE_MAX_LENGTH: 'specs.membership.IncreaseMaxLength',
  NEW_PLAN_CARD: 'specs.membership.NewPlanCard',
  BOOKINGS_SUBSCRIPTION_OVERVIEW_FIX: 'specs.membership.BookingsSubscriptionOverviewFix',
  ENABLE_SUBMISSION_TABLE: 'specs.membership.EnableSubmissionTable',
  MOTO_WITHOUT_REQUIRED_PAYMENT: 'specs.memberhip.MotoWithoutRequiredPayment',
  BENEFITS_KB_ARTICLE: 'specs.membership.BenefitsKbArticle',
  PIKACHU_SERVERLESS_MIGRATION: 'specs.membership.PikachuServerlessMigration',
  FORCE_ALLOW_CANCELLATION_FOR_UNLIMITED: 'specs.membership.ForceAllowCancelForUnlimited',
  HAS_RECURRING_PAYMENTS_FIX: 'specs.membership.HasRecurringPaymentsFix'
};
exports.BM_EXPERIMENTS = BM_EXPERIMENTS;
//# sourceMappingURL=bm.js.map